import { Controller } from "@hotwired/stimulus"

const FIELDS_BY_TYPE = {
  ask_full_name: ["prompt", "reask"],
  ask_text: ["prompt", "reask"],
  ask_cpf: ["prompt", "reask"],
  ask_date: ["prompt", "reask"],
  ask_number: ["prompt", "reask"],
  send_message: ["message"],
  compute: ["source_key", "function", "target_key"],
  condition: ["answer_key", "operator", "value", "then_step_key", "else_step_key"],
  handoff_human: [],
  disqualify: ["message"]
}

export default class extends Controller {
  static targets = ["steps", "template"]

  connect() {
    this.visibleSteps().forEach((row) => this.applyFieldVisibility(row))
    this.refreshStepKeyDatalist()
    this.keyInputHandler = (event) => {
      if (event.target.matches("input[name$='[key]']")) this.refreshStepKeyDatalist()
    }
    this.element.addEventListener("input", this.keyInputHandler)
  }

  disconnect() {
    this.element.removeEventListener("input", this.keyInputHandler)
  }

  addStep(event) {
    event.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    const index = this.visibleSteps().length
    this.replaceIndex(content, index)
    this.stepsTarget.appendChild(content)
    this.applyFieldVisibility(this.visibleSteps().at(-1))
    this.renumberPositions()
  }

  stepTypeChanged(event) {
    const row = event.target.closest("[data-preattendance-bot-editor-target='step']")
    this.applyFieldVisibility(row)
  }

  removeStep(event) {
    event.preventDefault()
    const row = event.target.closest("[data-preattendance-bot-editor-target='step']")
    const destroyInput = row.querySelector("input[name*='[_destroy]']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
    this.renumberPositions()
  }

  moveUp(event) {
    event.preventDefault()
    const row = event.target.closest("[data-preattendance-bot-editor-target='step']")
    const visibleSteps = this.visibleSteps()
    const index = visibleSteps.indexOf(row)
    if (index > 0) {
      this.stepsTarget.insertBefore(row, visibleSteps[index - 1])
      this.renumberPositions()
    }
  }

  moveDown(event) {
    event.preventDefault()
    const row = event.target.closest("[data-preattendance-bot-editor-target='step']")
    const visibleSteps = this.visibleSteps()
    const index = visibleSteps.indexOf(row)
    if (index >= 0 && index < visibleSteps.length - 1) {
      this.stepsTarget.insertBefore(visibleSteps[index + 1], row)
      this.renumberPositions()
    }
  }

  visibleSteps() {
    return Array.from(this.stepsTarget.querySelectorAll("[data-preattendance-bot-editor-target='step']"))
      .filter((row) => !row.classList.contains("hidden"))
  }

  renumberPositions() {
    this.visibleSteps().forEach((row, index) => {
      const positionInput = row.querySelector("input[name*='[position]']")
      if (positionInput) positionInput.value = index + 1
    })
    this.refreshStepKeyDatalist()
  }

  replaceIndex(node, index) {
    node.querySelectorAll("[name]").forEach((element) => {
      element.name = element.name.replace(/NEW_INDEX/g, index)
      if (element.id) element.id = element.id.replace(/NEW_INDEX/g, index)
    })
    node.querySelectorAll("[for]").forEach((element) => {
      element.htmlFor = element.htmlFor.replace(/NEW_INDEX/g, index)
    })
  }

  applyFieldVisibility(row) {
    const type = row.querySelector("select[name*='[step_type]']")?.value
    const visibleFields = FIELDS_BY_TYPE[type] || []
    row.querySelectorAll("[data-step-field]").forEach((field) => {
      field.classList.toggle("hidden", !visibleFields.includes(field.dataset.stepField))
    })
  }

  refreshStepKeyDatalist() {
    const datalist = this.element.querySelector("#preattendance-step-keys")
    if (!datalist) return

    const keys = this.visibleSteps()
      .map((row) => row.querySelector("input[name$='[key]']")?.value.trim())
      .filter((key, index, values) => key && values.indexOf(key) === index)
    datalist.replaceChildren(...keys.map((key) => {
      const option = document.createElement("option")
      option.value = key
      return option
    }))
  }
}
